import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginSide, logoIcon } from '../../ui/media';
import { useLogin } from "../../../hooks/useAuth"
import toast from 'react-hot-toast';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate()
  const loginMutation = useLogin()

  const checkEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  const handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    if (email.trim() == "" || !checkEmail(email)) {
      toast.error("Please put valid email address to proceed.")
      return false
    }
    if (password.trim() == "") {
      toast.error("Please enter your account password to proceed.")
      return false
    }
    const loginData = {
      email,
      password
    }
    loginMutation.mutate(loginData, {
      onSuccess: () => {
        toast.success('Login success');
        navigate('/dashboard')
      },
      onError: (error) => {
        const message = error.response?.data?.message || "Login failed"
        toast.error(message)
      }
    })
  };

  return (
    <div className="flex h-screen w-full bg-black text-white">
      {/* Left side with image and testimonial */}
      <div className="relative w-1/2 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-black/70 z-10"></div>
        {/* Background image */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${loginSide})`,
            filter: 'brightness(0.7) sepia(0.2)'
          }}>
        </div>
        {/* Decorative lights */}
        <div className="absolute inset-0 z-0">
          {[...Array(6)].map((_, i) => (
            <div
              key={i}
              className="absolute w-6 h-16 bg-amber-300/80 rounded-full blur-sm"
              style={{
                top: `${20 + (i * 15)}%`,
                left: `${15 + ((i % 3) * 30)}%`,
                boxShadow: '0 0 15px 5px rgba(251, 191, 36, 0.4)'
              }}
            ></div>
          ))}
        </div>
        {/* Logo */}
        <div className="absolute top-6 left-6 z-20 flex items-center">
          <span className="text-white font-semibold flex items-center">
            <img
              src={logoIcon}
              className="w-6 h-6 mr-2" />
            Newboo Inc
          </span>
        </div>
        {/* Testimonial */}
        <div className="absolute bottom-10 left-6 right-6 z-20">
          <p className="text-xl font-medium leading-relaxed mb-4">
            "This library has saved me countless hours of work and helped me deliver stunning designs to my clients faster than ever before."
          </p>
          <p className="text-sm">Sofia Davis</p>
        </div>
      </div>
      {/* Right side with login form */}
      <div className="w-1/2 flex items-center justify-center bg-white">
        <div className="w-4/5 max-w-md p-6">
          <div className="text-left mb-8">
            <h1 className="text-2xl font-bold text-gray-800 mb-2">Login</h1>
            <p className="text-gray-600">Enter your email below to login to your account</p>
          </div>
          <div>
            <div className="mb-4">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <input
                type="email"
                value={email}
                placeholder="Enter email"
                onChange={(e) => setEmail(e.target.value)}
                className="w-full text-black px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className="mb-6">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                className="w-full text-black px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <div className="flex justify-end mt-1">
                <button
                  onClick={() => navigate('/forgot-password')}
                  className="text-sm text-gray-600 hover:text-gray-800">
                  Forgot your password?
                </button>
              </div>
            </div>
            <button
              onClick={handleSubmit}
              className="w-full bg-gray-800 text-white py-2 px-4 rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 mb-4">
              Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Login;